import TableCsvDownload from 'components/common/table/csv/TableCsvDownload';
import CommonTableHeader from 'components/common/table/header/CommonTableHeader';
import { Fragment } from 'react';
import { TenantUsage } from 'types/feature/statistics/tenantUsage';
import { TENANT_USAGE_TABLE_HEADER } from './head/tenantUsageTableHead';
import { TENANT_USAGE_TABLE_HEADER_WITHOUT_POINT } from './head/tenantUsageTableHeadWithoutPoint';

type Props = {
  tenantUsageList: TenantUsage[];
  isAll: boolean;
  onClickDownload: () => Promise<void>;
};

const TenantUsageTable = ({ tenantUsageList, isAll, onClickDownload }: Props) => {
  return (
    <div className='flex flex-col w-full gap-3 px-10 pt-6 pb-10 bg-white border border-gray-ea'>
      {/* 총 개수, 다운로드 버튼 */}
      <TableCsvDownload totalCount={tenantUsageList?.length || 0} onClickDownload={onClickDownload} />

      <table className='w-full border-collapse'>
        {/* 전체일 경우 빌딩 이름 노출 */}
        {isAll ? (
          <CommonTableHeader tableHead={TENANT_USAGE_TABLE_HEADER} />
        ) : (
          <CommonTableHeader tableHead={TENANT_USAGE_TABLE_HEADER_WITHOUT_POINT} />
        )}
        {tenantUsageList?.map((data, index) => (
          <Fragment key={data.tenantId}>
            <tbody>
              <tr className='h-[52px] text-[14px]'>
                {/* 순위 */}
                <td className='border-b p-2.5'>{index + 1}</td>

                {/* 매장명 */}
                <td className='border p-2.5'>{data.tenantName.ko}</td>

                {/* 빌딩 - 전체 빌딩일 경우만 노출 */}
                {isAll && <td className='border p-2.5'>{data.pointName.ko}</td>}

                {/* 층 */}
                <td className='border p-2.5'>{data.floorName.ko}</td>

                {/* 층별안내 진입수 */}
                <td className='border p-2.5 bg-bg-f9'>{Number(data.detailOfFloorCount).toLocaleString()}</td>

                {/* 매장검색 진입수 */}
                <td className='border p-2.5 bg-bg-f9'>{Number(data.detailOfTenantCount).toLocaleString()}</td>

                {/* 전체 진입수 */}
                <td className='border p-2.5'>{Number(data.totalCount).toLocaleString()}</td>

                {/* 길찾기 진행건 */}
                <td className='border border-r-0 p-2.5'>{Number(data.navigationCount).toLocaleString()}</td>
              </tr>
            </tbody>
          </Fragment>
        ))}
      </table>
    </div>
  );
};
export default TenantUsageTable;
